import React, { Component } from "react";
import { Redirect, Route } from "react-router-dom";
import Auth from "./Auth";

class PrivateRouter extends Component {
  render() {
    const { component: Component, requiredRole, ...rest } = this.props;
    let user = JSON.parse(localStorage.getItem("auth"));

    if (user != null && user.authenticated) {
      if (user.roles && ( !requiredRole || Auth.hasRole(requiredRole))) {
        return <Route {...rest} render={(props) => <Component {...props} />} />;
      } else {
        return <Redirect to={{ pathname: "/unauthorized" }} />;
      }
    } else {
      return (
        <Redirect to={{ pathname: "/login", state: { from: this.props.location } }} />
      );
    }
  }
}

export default PrivateRouter;
